import React from 'react';
import Fullscreen from 'react-full-screen';
import { isMobileSafari } from 'react-device-detect';
import get from 'lodash/get';
import Bem from 'bemHelper';
import DataProvider from 'api/data-provider';
import { Leaflet, Maps, InfoLayer, BaseLayersUser, InfoLayerBboxWrapper, FullscreenControl } from 'containers/maps';
import StreetView from 'components/street-view';
import Row, { Col } from 'components/row';

import { getReferencePoints } from './render-common';

import marker from '../assets/map-marker';
import { mapTile, complexMapTile } from '../section-projects/common';
import MapCard from '../section-projects/tile-card';

const bemClasses = new Bem('project');

export function mapMarkerFunc(point, latLng) {
  return Leaflet.marker(latLng, { icon: marker() });
}

export function handleMarkerClickFunc(evt) {
  const handleMarkerId = get(evt, 'target.feature.properties.id');
  this.setState({ handleMarkerId });
}

export function clickOutsideMapCardFunc(evt) {
  if (evt.target.id !== 'fullscreen') {
    this.setState({ handleMarkerId: null });
  }
}

export function mapTileRendererFunc(payload) {
  return mapTile.call(this, payload, MapCard);
}

export function handleScreenClickFunc() {
  this.setState({ isFullScreenMode: !(this.state.isFullScreenMode) });
}

export function renderBlockMap(project, landing) {
  const { i18n } = this;
  const { streetView, isFullScreenMode } = this.state;
  const { advanced_info = {}, ...rest } = project;
  const propsGroup = { ...advanced_info, ...rest };
  const {
    fullAddress, subways, landmarks, geo, geo_centroid, street_view, id, type
  } = propsGroup;
  const complMapTile = complexMapTile.call(this);
  const mapSwitchBtns = {};

  if (!geo || !id || !geo_centroid) return null;
  const slicedNum = get(this, 'props.params.content') === 'object' ? -2 : -1;
  const fullAdd = get(landing, 'breadcrumbs', []).slice(1, slicedNum);
  fullAdd.push(fullAddress.building_address);

  return (
    <div {...bemClasses('blockMap')} ref={ref => this.refBlockMap = ref}>
      <Row {...bemClasses('rowTopic')}>
        <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={i18n('mapTopic')} /></div></Col>
      </Row>
      <div {...bemClasses('content')}>
        {getReferencePoints.call(this, bemClasses, fullAdd, 'fullAddress')}
        {getReferencePoints.call(this, bemClasses, subways, 'subwaysMap')}
        {getReferencePoints.call(this, bemClasses, landmarks, 'landmarksMap')}
      </div>
      {/* TODO ВЫВОД ДАННЫХ О ДОМЕ И ПЛАНИРОВКАХ - ЗАВЕРСТАТЬ DOMIK-2459 ТАСК ВРЕМЕННО ОТЛОЖЕН  */}
      {/* this.renderHouseInfo() */}
      <div {...bemClasses('mapContainer')}>
        {!streetView &&
          <Fullscreen
            enabled={isFullScreenMode}
            onChange={
              isFullScreen => this.setState({
                isFullScreenMode: isFullScreen
              })
            }
          >
            <Maps
              {...bemClasses('map')}
              noAutoGeolocate
              adaptiveScrollZoom={2000}
              maxZoom={17}
            >
              <BaseLayersUser
                key="bl"
                defLayer="gstreet"
                positionLayerSwitch="bottomleft"
                advancedButtons={mapSwitchBtns}
              />
              {!isMobileSafari &&
                <FullscreenControl
                  key="fs"
                  isFullscreen={isFullScreenMode}
                  onScreenIconClick={this.handleScreenClick}
                  position="topleft"
                />
              }
              <InfoLayerBboxWrapper
                provider="domik/location/newbuilds-list-map"
                query={{ idNot: id, type, unsold: true, objectGroup: 'flats' }}
                deferRequestData={1000}
                cluster
                order={1}
                spiderfyDistanceMultiplier={1.5}
                maxClusterRadius={50}
                showCoverageOnHover={false}
                pointToLayer={this.mapMarker}
                onFeatureClick={this.handleMarkerClick}
              />
              <InfoLayer
                key="gc"
                noAutoFit
                data={[geo_centroid]}
                maxZoom={14}
                order={2}
                markerProps={{ icon: marker('standartBig') }}
              />
              <InfoLayer
                fitMaxZoom={13}
                minZoom={15}
                key="il"
                order={3}
                data={[geo]}
              />
              <DataProvider url="bild/address-gis-layer" query={{ toponym: id }}>
                <InfoLayer
                  order={4}
                  onFeatureClick={this.handleMapHouseClick}
                  fitMaxZoom={16}
                  labelsMinZoom={16}
                  minZoom={15}
                  key="il_adr"
                  labelField="display_name"
                  typeStyleProp="type"
                  typeStyles={{
                    address: {
                      weight: 1,
                      fill: '#fcfcfc',
                      color: '#7a8191'
                    },
                    building_queue: {
                      weight: 1,
                      fillColor: '#b2ae1b',
                      color: '#b2ae1b'
                    }
                  }}
                />
              </DataProvider>
            </Maps>
            {complMapTile}
          </Fullscreen>
        }
        {streetView &&
          <StreetView
            {...bemClasses('map')}
            value={street_view}
            onClose={() => this.setState({ streetView: false })}
          />
        }
      </div>
    </div>
  );
}
